"use strict";

exports.__esModule = true;
exports["default"] = exports.YoutubeVideo = exports.YouTubeContainer = exports.HtmlYouTube = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YouTubeContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "youtube__YouTubeContainer",
  componentId: "sc-rqtsvh-0"
})(["position:relative;overflow:hidden;z-index:1;"]);
exports.YouTubeContainer = YouTubeContainer;
var YoutubeVideo = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "youtube__YoutubeVideo",
  componentId: "sc-rqtsvh-1"
})(["padding-bottom:56.25%;position:relative;width:100%;iframe{display:block;height:100%;left:0;position:absolute;top:0;width:100%;}"]);
exports.YoutubeVideo = YoutubeVideo;
var propTypes = {
  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** playlist id for youtube video */
  playlistId: _propTypes.string,

  /** video id for youtube video */
  videoId: _propTypes.string
};
var defaultProps = {
  playlistId: "",
  videoId: ""
};

var HtmlYouTube = function HtmlYouTube(_ref) {
  var dataTestId = _ref["data-test-id"],
      playlistId = _ref.playlistId,
      videoId = _ref.videoId;
  var url = (0, _react.useMemo)(function () {
    return "https://www.youtube.com/embed/" + videoId + "?list=" + playlistId + "&enablejsapi=1";
  }, [playlistId, videoId]);
  return /*#__PURE__*/_react["default"].createElement(YouTubeContainer, {
    "data-test-id": dataTestId,
    my: 4
  }, /*#__PURE__*/_react["default"].createElement(YoutubeVideo, null, /*#__PURE__*/_react["default"].createElement("iframe", {
    allowFullScreen: true,
    frameBorder: "0",
    height: "720",
    src: url,
    title: "Youtube " + videoId,
    width: "1280"
  })));
};

exports.HtmlYouTube = HtmlYouTube;
HtmlYouTube.defaultProps = defaultProps;
HtmlYouTube.propTypes = propTypes;
HtmlYouTube.displayName = "Modules.HtmlYouTube";
var _default = HtmlYouTube;
exports["default"] = _default;